import * as React from "react";
import { Redirect } from "react-router-dom";
import i18n from "src/common/i18n";
import { DEFAULT_LOCALE } from "src/config";
import AdminRoles from "src/modules/Dashboard/AdminRoles/view";
import AnonymousFeedback from "src/modules/Dashboard/AnonymousFeedback/view";
import AnonymousFeedbackSummary from "src/modules/Dashboard/AnonymousFeedbackSummary/view";
import CreateCycle from "src/modules/Dashboard/Cycles/CreateCycle/view";
import CreateUpdateTemplate from "src/modules/Dashboard/Templates/CreateUpdateTemplate/view";
import CyclesList from "src/modules/Dashboard/Cycles/CyclesList/view";
import Login from "src/modules/CurrentUser/views/Login";
import LoginError from "src/modules/CurrentUser/views/LoginError";
import ManagerDashboard from "src/modules/Dashboard/ManagerDashboard/view";
import MyActionPlans from "src/modules/Dashboard/ActionPlans/MyActionPlansPage/view";
import MyDirectReportsActionPlans from "src/modules/Dashboard/ActionPlans/MyDirectReportsActionPlansPage/view";
import MyEmployees from "src/modules/Dashboard/MyEmployees/view";
import MyFeedbacks from "src/modules/Dashboard/MyFeedbacks/view";
import MyPeerQuestionnaire from "src/modules/MyPeerQuestionnaire/view";
import MyPeers from "src/modules/Dashboard/MyPeers/view";
import MyQuestionnaire from "src/modules/MyQuestionnaire/view";
import PeerSelection from "src/modules/Dashboard/PeerSelection/view";
import PeerSummary from "src/modules/Dashboard/PeerSummary/view";
import AnonTeamSummaryPage from "src/modules/Dashboard/AnonTeamSummary/view";
import TalkSheet from "src/modules/TalkSheet/view";
import TemplateList from "src/modules/Dashboard/Templates/TemplateList/view";
import UploadParticipants from "src/modules/Dashboard/Cycles/UploadParticipants/view";
import { CycleParticipantsPage } from "src/modules/Dashboard/Cycles/CycleParticipants/view";

let lng = DEFAULT_LOCALE;
const selectedLanguage = localStorage.getItem("selectedLanguage");
if (selectedLanguage) {
  lng = selectedLanguage;
  i18n.changeLanguage(lng);
}

const Routes = {
  AdminRoles,
  AnonymousFeedback,
  AnonymousFeedbackSummary,
  AnonTeamSummaryPage,
  CreateCycle,
  CreateUpdateTemplate,
  CycleParticipantsPage,
  CyclesList,
  LogIn: Login,
  LoginError,
  ManagerDashboard,
  MyActionPlans,
  MyDirectReportsActionPlans,
  MyEmployees,
  MyFeedbacks,
  MyPeerQuestionnaire,
  MyPeers,
  MyQuestionnaire,
  PeerSelection,
  PeerSummary,
  RedirectToMain: () => <Redirect to={`/${lng}/dashboard/forward`} />,
  TalkSheet,
  TemplateList,
  UploadParticipants
};

export default Routes;
